import { useState, useCallback, useEffect } from "react";
const useReCaptchaV3 = () => {
  const [isReCaptchaReady, setIsReCaptchaReady] = useState(false);

  useEffect(() => {
    if (window.grecaptcha) {
      setIsReCaptchaReady(true);
    } else {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY_V3}`;
      script.async = true;
      document.head.appendChild(script);
      script.onload = () => setIsReCaptchaReady(true);
    }
  }, []);

  const executeReCaptcha = useCallback(
    async (action) => {
      return new Promise((resolve, reject) => {
        if (isReCaptchaReady && window.grecaptcha) {
          window.grecaptcha.ready(() => {
            window.grecaptcha
              .execute(process.env.REACT_APP_RECAPTCHA_KEY_V3, { action })
              .then((token) => resolve(token))
              .catch((error) => reject(error));
          });
        } else {
          reject(new Error("ReCAPTCHA is not ready"));
        }
      });
    },
    [isReCaptchaReady]
  );

  return [isReCaptchaReady, executeReCaptcha];
};

export default useReCaptchaV3;
